<div class="crud-modal-wrapper">
  <!-- Cabecera Soft UI / Glassmorphism -->
  <header class="crud-modal-header">
    <div class="header-main-row">
      <button class="modal-close-btn" (click)="closeModal(false)">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </button>

      <div class="title-group">
        <h2 class="title-main">{{ isEditing ? 'Editar ' + entityName : 'Nuevo ' + entityName }}</h2>
        <span class="title-sub">{{ isEditing ? 'Actualización de datos y parámetros' : 'Registro de nuevo elemento en el catálogo' }}</span>
      </div>

      <div class="header-badge" [ngStyle]="{'color': iconColor}">
        <ion-icon [name]="iconName"></ion-icon>
      </div>
    </div>
  </header>

  <!-- Contenido con Scroll Nativo Ionic -->
  <ion-content class="modal-body-content" [scrollY]="true">
    <div class="form-container">

      <!-- Tarjeta de Campos Principales -->
      <div class="form-section-card">
        <div class="card-section-header">
          <div class="section-icon-wrap" [ngStyle]="{'color': iconColor, 'background': 'rgba(91, 138, 245, 0.12)'}">
            <ion-icon [name]="iconName"></ion-icon>
          </div>
          <div>
            <h3 class="section-title">Datos del Registro</h3>
            <p class="section-subtitle">Completa la información requerida</p>
          </div>
        </div>

        <div class="grid-inputs">
          <ng-container *ngFor="let field of entityFields">
            <div class="field-group" [class.full-width]="field.type === 'textarea'">
              <label class="field-label">
                <ion-icon [name]="getFieldIcon(field.label)"></ion-icon>
                <span>{{ field.label }}</span>
              </label>

              <!-- Text/Number -->
              <div class="clean-input-box" *ngIf="field.type === 'text' || field.type === 'number'">
                <input 
                  [type]="field.type === 'number' ? 'number' : 'text'" 
                  [(ngModel)]="currentData[field.key]" 
                  [placeholder]="field.label">
              </div>

              <!-- Textarea -->
              <div class="clean-textarea-box" *ngIf="field.type === 'textarea'">
                <textarea 
                  [(ngModel)]="currentData[field.key]" 
                  [placeholder]="field.placeholder || field.label" 
                  rows="4"></textarea>
              </div>

              <!-- Selector Genérico Modal con Buscador -->
              <div class="clean-input-box select-field clickable-selector" *ngIf="field.type === 'select'" (click)="openGenericSelector(field)">
                <span class="selector-display-text" [class.empty-placeholder]="!currentData[field.key]">
                  {{ getSelectedOptionLabel(field) || ('Seleccionar ' + field.label) }}
                </span>
                <ion-icon name="chevron-forward-outline" class="select-chevron-icon"></ion-icon>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- Clientes Vinculados (para SOLICITANTE en modo edición) -->
        <div class="assigned-clients-box" *ngIf="entity === 'SOLICITANTE' && isEditing && getSolicitanteClients(currentData.dt1).length > 0">
          <div class="assigned-clients-title">
            <ion-icon name="business-outline"></ion-icon>
            <span>Clientes Vinculados ({{ getSolicitanteClients(currentData.dt1).length }})</span>
          </div>
          <div class="assigned-clients-chips">
            <div class="client-link-chip" *ngFor="let client of getSolicitanteClients(currentData.dt1)">
              <span class="client-chip-name">{{ client.nombre }}</span>
              <button class="client-chip-del" (click)="unlinkClient(currentData.dt1, client.id)" title="Desvincular cliente">
                <ion-icon name="close-circle"></ion-icon>
              </button>
            </div>
          </div>
          <p class="assigned-clients-hint">Para asociar un cliente adicional, selecciónalo en el campo superior y presiona Guardar.</p>
        </div>
      </div>

    </div>
  </ion-content>

  <!-- Footer Fijo de Acciones -->
  <footer class="modal-footer-bar">
    <button *ngIf="isEditing" class="btn-action-delete" (click)="confirmDelete()" [disabled]="loading">
      <ion-icon name="trash-outline"></ion-icon>
      <span>Eliminar</span>
    </button>

    <button class="btn-action-save" (click)="saveItem()" [disabled]="loading">
      <ion-spinner *ngIf="loading" name="crescent"></ion-spinner>
      <ng-container *ngIf="!loading">
        <ion-icon [name]="isEditing ? 'save-outline' : 'checkmark-circle-outline'"></ion-icon>
        <span>{{ isEditing ? 'Guardar Cambios' : 'Crear Registro' }}</span>
      </ng-container>
    </button>
  </footer>
</div>
